// src/pages/SignupPage.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import toast from 'react-hot-toast';

const SignupPage = () => {
  const navigate = useNavigate();
  const { signUp, signInWithGoogle } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    setLoading(true);
    try {
      await signUp(email, password, name);
      toast.success('Welcome to Gather! 🎉');
      navigate('/');
    } catch (err) {
      toast.error(err.code === 'auth/email-already-in-use' ? 'That email is already registered' : 'Sign up failed. Please try again.');
    }
    setLoading(false);
  };

  const handleGoogle = async () => {
    try { await signInWithGoogle(); navigate('/'); }
    catch { toast.error('Google sign in failed'); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--cream)', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '60px 24px 40px' }}>
      <div style={{ width: 100, height: 100, background: 'var(--sage)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 24, position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 6, borderRadius: '50%', border: '1.5px solid rgba(255,255,255,0.35)' }} />
        <span style={{ fontFamily: 'Nunito', fontSize: 24, fontWeight: 400, color: 'var(--sage-dark)' }}>Gather</span>
      </div>
      <h1 style={{ fontSize: 26, fontWeight: 800, color: 'var(--ink)', marginBottom: 6 }}>Create your account</h1>
      <div style={{ fontSize: 14, color: 'var(--muted)', fontWeight: 500, marginBottom: 28 }}>Free — takes 30 seconds</div>

      <button onClick={handleGoogle} style={{ width: '100%', background: 'var(--white)', border: '1.5px solid var(--border)', borderRadius: 14, padding: 15, fontSize: 15, fontWeight: 700, fontFamily: 'Nunito', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 20 }}>
        🔵 Continue with Google
      </button>
      <div style={{ width: '100%', textAlign: 'center', fontSize: 13, color: 'var(--muted)', fontWeight: 600, marginBottom: 20 }}>or</div>

      <form style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 14 }} onSubmit={handleSignup}>
        {[['Your name', name, setName, 'text', 'e.g. Siobhán Murphy'], ['Email', email, setEmail, 'email', 'your@email.com'], ['Password', password, setPassword, 'password', '••••••••']].map(([lbl, val, setter, type, ph]) => (
          <label key={lbl} style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <span style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.2px', color: 'var(--muted)' }}>{lbl}</span>
            <input className="form-input" type={type} value={val} onChange={e => setter(e.target.value)} placeholder={ph} required />
          </label>
        ))}
        <button type="submit" style={{ width: '100%', background: 'var(--sage-deep)', color: 'white', border: 'none', borderRadius: 16, padding: 17, fontSize: 16, fontWeight: 700, fontFamily: 'Nunito', cursor: 'pointer', opacity: loading ? 0.7 : 1 }} disabled={loading}>
          {loading ? 'Creating account...' : 'Create account'}
        </button>
      </form>
      <div style={{ marginTop: 20, fontSize: 14, color: 'var(--muted)', fontWeight: 500 }}>
        Already have an account? <Link to="/login" style={{ color: 'var(--sage-deep)', fontWeight: 700 }}>Sign in</Link>
      </div>
    </div>
  );
};

export default SignupPage;
